import { render, staticRenderFns } from "./lotto-round.vue?vue&type=template&id=64ec2f54&"
import script from "./lotto-round.vue?vue&type=script&lang=js&"
export * from "./lotto-round.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports